export default "__VITE_ASSET__B_d78L10__"